import { Component, OnInit } from '@angular/core';
import { CarLinkService } from 'src/app/core/services/car-link/car-link.service';
import { IMake, IModel } from 'src/app/core/models/google-map-models';
import { AppSettings } from 'src/app/core/shared';
import { UntypedFormGroup, FormControl, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-car-models-section',
    templateUrl: './car-models-section.component.html',
    styleUrls: ['./car-models-section.component.scss'],
    providers: [CarLinkService],
    standalone: false
})

export class CarModelsSectionComponent implements OnInit {

  public makes: IMake[];
  public models: Array<IModel>;
  public usedCarModel: UntypedFormGroup;
  private allModels: Array<any>;
  private readonly initialValue: string = '-1';

  constructor(private carLinkService: CarLinkService,
    private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.carLinkService.getLoadMake().subscribe((usedCars: any) => {
      this.makes = usedCars.data.makes;
      this.allModels = usedCars.data.model;
    });
    this.initUsedCarModelForm();
  }

  initUsedCarModelForm() {
    this.usedCarModel = this.fb.group({
      make: this.initialValue,
      model: [{ value: this.initialValue, disabled: true }],
      postCode: ''
    });
  }

  onChangedMake(event: any) {
    const make = event.target.value;
    this.models = this.allModels[make];
    this.usedCarModel.controls['model'].enable();
    if (this.models === undefined) {
      this.usedCarModel.controls['model'].disable();
    }
    this.usedCarModel.patchValue({ 'model': this.initialValue });
  }

  redirectToDisplayCars(): void {
    let maker = '';
    let model = '';
    const selectedMakes = this.makes.filter(r => r.id === +this.usedCarModel.value.make);
    model = this.usedCarModel.value.model;
    if (selectedMakes.length > 0) {
      maker = selectedMakes[0].name;
      model = ' ' + model;
    }
    if (this.usedCarModel.value.model === '-1' || this.usedCarModel.value.model === undefined) {
      model = '';
    }
    const params = `&keywordsearch=${maker}${model}&fullpostcode=${this.usedCarModel.value.postCode || ''}`;
    const displayCars = window.open(AppSettings.API_USEDCAR_BASEURL + params, 'AAUsedCars');
    if (displayCars !== null) { displayCars.focus(); }
  }

  trackByFn(index: number): number {
    return index;
  }
}
